import React from 'react'
import { observer } from 'mobx-react-lite'

import { TableCell } from '@material-ui/core'

import { MoySkladProductPricesButton } from '../MoySkladProductPricesButton'

import { MyRowProps } from '../../types/tableTypes'
import { MoySkladProductModel } from '../../server/mpsklad_core/Models/MoySkladProductModel'

export const MoySkladProductPricesCell =
  observer(
    ({row}: MyRowProps<MoySkladProductModel>) =>
      <TableCell>
        <MoySkladProductPricesButton prices={row.prices}/>
      </TableCell>)